<template>
  <div class="container text-secondary">
    <div class="row mb-3">
      <div class="col-2"/>
      <div class="col text-center">
        <img src="@/assets/crowd-100.png" alt="" class="img-fluid d-inline-block" style="height:36px;"/>
        <div class="h4 d-inline-block ms-2">Spelers</div>
      </div>
      <div class="col-2 text-end pe-2">
        <img src="@/assets/back-48.png" alt="terug" class="img-fluid"
             style="height:32px; cursor:pointer;" @click="$router.push('/')"/>
      </div>
    </div>

    <hr class="divider">

    <!-- Nieuwe speler toevoegen -->
    <div class="card-modern">
      <div style="font-weight:700; color:#4a5568; margin-bottom:12px;">Nieuwe speler</div>

      <input
          type="text"
          class="naam-input mb-3"
          v-model="naam"
          placeholder="Naam van de speler"
          @keyup.enter="addPlayer"
      />

      <div style="display:flex; gap:12px; margin-bottom:16px;">
        <button class="gender-btn" :class="{ active: gender === 'male' }" @click="gender = 'male'">
          👨 Man
        </button>
        <button class="gender-btn" :class="{ active: gender === 'female' }" @click="gender = 'female'">
          👩 Vrouw
        </button>
      </div>

      <button class="btn-primary-modern" style="width:100%;"
              :disabled="!naam.trim()" @click="addPlayer">
        Toevoegen
      </button>
    </div>

    <!-- Spelerslijst -->
    <div v-if="players.length === 0" style="text-align:center; color:#a0aec0; padding:20px;">
      Nog geen spelers
    </div>

    <div v-else>
      <div v-for="player in players" :key="player.id" class="speler-rij">
        <span style="font-size:1.3rem;">{{ player.gender === 'female' ? '👩' : '👨' }}</span>
        <span class="speler-naam">{{ player.name }}</span>
        <img src="@/assets/remove-48.png" alt="verwijderen" class="img-fluid"
             style="height:28px; cursor:pointer; opacity:0.6;"
             @click="removePlayer(player.id)"/>
      </div>
    </div>

    <!-- Preset knop -->
    <div class="text-center mt-3">
      <button class="preset-btn" @click="laadPreset">
        🎲 Laad testspelers
      </button>
    </div>
  </div>
</template>

<script>
import store from "@/store";

export default {
  name: "PlayersLounge",
  data() {
    return {
      naam: '',
      gender: 'male',
      preset: [
        { name: 'Arnold',  gender: 'male'   },
        { name: 'Corrie',  gender: 'female' },
        { name: 'Lilian',  gender: 'female' },
        { name: 'Bart',    gender: 'male'   },
        { name: 'Saskia',  gender: 'female'   },
        { name: 'Ambi',  gender: 'female' },
        { name: 'Marito',  gender: 'female' },
        { name: 'Oma Lia',    gender: 'female' },
        { name: 'Marcel',  gender: 'male'   },
        { name: 'Anja',  gender: 'female' },
        { name: 'Dana',  gender: 'female' },
        { name: 'Ben',    gender: 'male'   },
        { name: 'Saar',  gender: 'female'   },
        { name: 'Oma Bets',  gender: 'female' },
        { name: 'Opa Peter',  gender: 'male' },
      ],
    };
  },
  computed: {
    players() {
      return store.state.players;
    },
  },
  methods: {
    addPlayer() {
      if (!this.naam.trim()) return;
      store.commit('addPlayer', {
        id: this.generateUUID(),
        name: this.naam.trim(),
        gender: this.gender,
      });
      this.naam = '';
    },
    removePlayer(id) {
      store.commit('removePlayer', id);
    },
    laadPreset() {
      // Verwijder bestaande spelers eerst
      store.state.players.forEach(p => store.commit('removePlayer', p.id));
      // Voeg preset spelers toe
      this.preset.forEach(p => {
        store.commit('addPlayer', {
          id: this.generateUUID(),
          name: p.name,
          gender: p.gender,
        });
      });
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    },
  },
}
</script>

<style scoped>
.naam-input {
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;
}
.naam-input:focus { border-color: #667eea; }
.gender-btn {
  flex: 1;
  padding: 10px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  background: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.gender-btn.active { border-color: #667eea; background: #ebf4ff; color: #667eea; }
.speler-rij {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border-radius: 12px;
  padding: 10px 14px;
  margin-bottom: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.speler-naam { flex: 1; font-weight: 600; color: #2d3748; }
.preset-btn {
  background: none;
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  padding: 8px 20px;
  color: #a0aec0;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.15s;
}
.preset-btn:hover { border-color: #667eea; color: #667eea; }
</style>